import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ISort, translations } from './../../../../core/models/call-offer';
import { serverError } from './../../../../core/models/messages';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { OffreEsnService } from './../../../../core/services/offre-esn/offre-esn.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-list-offers-candidature',
  templateUrl: './list-offers-candidature.component.html',
  styleUrls: ['./list-offers-candidature.component.css'],
})
export class ListOffersCandidatureComponent {
  backGroundColors: string[] = ['blue', 'orange', 'bleu-clair', 'pink', 'rose'];
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  pagination : boolean =false;

  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listcandidature: any;
  urlimage: string = environment.baseUrlGaleryy;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList: any = [];
  mobilities: any[] = [];
  nameEsn = this.localStorageService.getData('clientConnectedName');
  listconsultant: any;
  selectedUserId!: string;
  iduser: any;
  isCollapsed = true;
  idoffre: any;
  idCompany:any; 
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },

  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  sortAttr = '';

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private offreesnservice: OffreEsnService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private jobofferservice: EsnJobOfferService,
    private appelofferservice: EsnAppeloffreService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig


  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getListcandidature();
    this.getListSkills();
    this.getlistconsultant();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchoffrebesoinesn();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListcandidature();
      }
    }
  }
  translateCountryName(name: string): string {
  
    return translations[name] || name;
  }
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }

  getListcandidature(sort?: ISort) {

    let idclientConnected = this.localStorageService.getData('clientConnected');
    let dataPyload =
      this.sortAttr == ''
        ? {
            company_id: idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.spinner.show();
    this.offreesnservice.getListcandidaturebesoinesn(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listcandidature = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchoffrebesoinesn();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobOffer: ['', data?.ID_jobOffer],
      name: ['', data?.name],
      esn_name: ['', data?.esn_name],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      contract_type: [[], data?.contract_type],
      post_type: [[], data?.post_type],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      city: [[], data?.city],
      country: [null, data?.country],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }

  /* search */
  searchoffrebesoinesn(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      company_id: this.idclientConnected,
      ID_jobOffer: valueForm.ID_jobOffer,
      esn_name: valueForm.esn_name,
      name: valueForm.name,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      city: valueForm.city,
      country: valueForm.country,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      start_date: formattedStartDate,
      end_date: formattedEndDate, 
      state: valueForm.state,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      per_page: this.itemsPerPage,
      page: pageNumber,
      search: this.transformSearch(valueForm?.search),
    };

    this.spinner.show();
    this.offreesnservice.searchcandidature(data).subscribe({
      next: (resSearch) => {
        if(this.startSearching == true) {
          this.currentPage = 1;
          this.startSearching = false;
        } 
          this.listcandidature = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  archiveroffrebesoinesn(id: any) {
    Swal.fire({
      title: 'Vous êtes sûr d’archiver l’offre sélectionnée ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, archiver !',
      cancelButtonText: 'Annuler',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.offreesnservice
          .archiveroffrebesoinesn(id)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’offre d’emploi a été archivé avec succès.'
                );
                this.getListcandidature();
                // this.route.navigateByUrl("/esn-offres-emploi/archived")
              }
            },
            error: (error: any) => {
            },
          });
      }
    });
  }

  bloquer() {
    Swal.fire({
      title: 'Es-tu sûr?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'oui, bloquer',
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  }

  ///////////////postuler///////////////////
  open(offre: any) {
    this.idoffre = offre.id;
  }
  getlistconsultant() {
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
      },
      error: (error) => {
      },
    });
  }
  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;
      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    }
  }

  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }

  postuleroffre() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_offer_id: this.idoffre,
    };
    this.jobofferservice.postuleroffre(data).subscribe({
      next: (res: any) => {
        this.toastrService.success(
          'votre candidature a été envoyé avec succès.'
        );
      },
      error: (error) => {
        if (error.error.message === 'candidature already exist.') {
          this.toastrService.error('Candidature existe déjà');
        }
        if (error.error.message === 'the job offer has been deactivated.') {
          this.toastrService.error(
            "La postulation n'est pas autorisée car l'offre d'emploi est désactivé."
          );
        }
      },
    });
  }

  retirercandidature(offre: any) {
    let data = {
      company_id: this.idclientConnected,
      user_id: offre.User_id,
      job_offer_id: offre.id,
    };
    Swal.fire({
      title: 'Êtes-vous sûr de vouloir retirer cette candidature ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, retirer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.offreesnservice.retirercandidature(data).subscribe({
          next: (res: any) => {
            this.toastrService.success(
              'votre candidature a été retiré avec succès.'
            );
            this.getListcandidature();
          },
          error: (error) => {
            if (error.error.message === 'candidature already exist.') {
              this.toastrService.error('Candidature existe déjà');
            }
            if (error.error.message === 'the job offer has been deactivated.') {
              this.toastrService.error(
                "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
              );
            }
          },
        });
      }
    });
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }


}
